import React from 'react';
import classes from './LotteryCardSkeleton.module.scss';

const LotteryCardSkeleton = () => (
  <div className={classes.Card}>
    <div className={classes.Header}>
      <span className={classes.Skeleton + ' ' + classes.CountryBadge} />
    </div>

    <div className={classes.LotteryInfo}>
      <span className={classes.Skeleton + ' ' + classes.Logo} />
      <div className={classes.LotteryInfoText}>
        <span className={classes.Skeleton + ' ' + classes.NameLine} />
        <span className={classes.Skeleton + ' ' + classes.CountdownLine} />
      </div>
    </div>

    <div className={classes.Content}>
      <span className={classes.Skeleton + ' ' + classes.MarketLabel} />
      <div className={classes.SuggestedRow}>
        <span className={classes.Skeleton + ' ' + classes.SuggestedButton} />
        <span className={classes.Skeleton + ' ' + classes.SuggestedButton} />
      </div>
    </div>
  </div>
);

export default LotteryCardSkeleton;
